<template>
  <div class="h-full bg-white mt-6">
    <div class="h-full bg-white rounded-lg outline outline-1 outline-gray-200 overflow-hidden">
      <div v-lazy-container="{ selector: 'img' }">
        <img
          v-if="post.cover"
          :data-src="`${ post.cover.url }`"
          :alt="`${ post.title } - ${ post.cover.alt }`"
          class="aspect-[7/4] h-full w-full object-cover object-center"
        >
        <img
          v-else
          data-src="https://images.vetster.com/illustrations/vetster-logo-over-gradient.jpg?ik-s=81d9166c8b7f0c8b03a8536700afdd184aaf5cc0"
          :alt="`${ post.title } - Vetster`"
          class="aspect-[7/4] h-full w-full object-cover object-center"
        >
      </div>
      <div class="pt-6 pb-8 px-4 lg:px-6 text-white flex flex-col justify-between">
        <div>
          <div class="flex flex-wrap justify-start items-center">
            <div
              v-if="post.post_type"
              class="flex flex-wrap font-medium text-xs leading-4 text-neutral-700 uppercase"
            >
              <span class="rounded-full bg-neutral-100 px-3 py-2 mt-2 mr-2">
                {{ post.post_type.title }}
              </span>
              <span
                v-if="hasSpeciesTypes"
                class="rounded-full bg-bubblegum-50 px-3 py-2 mt-2 mr-2"
              >
                {{ post.species_types[0]?.name }}
              </span>
              <span
                v-if="hasCategories"
                class="rounded-full bg-sunflower-50 px-3 py-2 mt-2 mr-2"
              >
                {{ post.categories[0]?.title }}
              </span>
            </div>
          </div>
          <div>
            <a
              :href="url"
              class="block"
              rel="noreferrer noopener"
            >
              <h3 class="mt-4 text-xl leading-7 font-semibold text-gray-900 hover:text-gray-500 ">
                {{ post.title }}
              </h3>

              <p
                v-if="post.intro"
                class="mt-4 text-base leading-6 text-gray-700 text-b-c line-clamp-3"
              >
                {{ post.intro }}
              </p>
            </a>
          </div>
        </div>
        <div class="vetster-small text-neutral-900 mt-8">
          <span class="font-semibold">{{ publishedDate }}</span>
          ·
          {{ $t('blogpost.min-read', { mins: post.read_time }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

import { i18n } from '@/i18n';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterPetConnectionPost',

  mixins: [LocalizesRoutes],

  props: {
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasCategories() {
      return this.post.categories?.length > 0;
    },
    hasSpeciesTypes() {
      return this.post.species_types?.length > 0;
    },
    publishedDate() {
      return DateTime.fromISO(this.post.published_at)
        .setLocale(i18n.locale)
        .toLocaleString(DateTime.DATE_MED);
    },
    url() {
      // PHP route('resources.budgeting.show')
      if (this.post.isBudgeting()) {
        return this.localizeUrl(`budgeting/${this.post.slug}`);
      }

      // PHP route('resources.glossary.show')
      if (this.post.isInGlossary()) {
        return this.localizeUrl(`glossary/${this.post.slug}`);
      }

      // PHP route('resources.type.show')
      return this.localizeLanguageUrl(`${this.post.post_type.slug}/${this.post.slug}`);
    },
  },
};
</script>
